<script lang="ts">
  import { isAuthenticated, isLoading as isLoadingAuth } from '@dopry/svelte-oidc'
  import { setContext } from 'svelte'
  import { getProducts, getProfile } from '../api'

  import type { Country, Profile } from '../api'
  import AccountInitialization from './AccountInitialization.svelte'
  import { profileContextKey } from './context'

  import Load from './Load.svelte'
  import normalizeInventories from './normalizeInventories'
  import SupportWidgetViewport from './SupportWidgetViewport.svelte'

  // Need to remove context in favor of svelte store API
  setContext(profileContextKey, {
    getUserId: (): string => profile?.id,
    getUserCountry: (): Country => userCountry,
    getProfile: (): Profile => profile,
    getMembershipId: (): string => profile?.membershipId,
    getEmail: (): string => profile?.email,
  })

  export let memberid = ''
  export let accountid = ''
  export let email = ''

  const productsQuery = getProducts()
  const profileQuery = getProfile(memberid, accountid)

  $: profile = $profileQuery.data?.profiles?.data?.[0]
  $: userCountry = profile?.country || 'US'
  $: inventories = normalizeInventories($productsQuery.data?.products?.data, userCountry)
</script>

{#if !(memberid || accountid)}
  <p class="container" data-cy="missing-account-id">
    accountid not specified. Please contact your system administrator for help. Most likely the link to this page is
    missing the <code>?accountid</code> parameter.
  </p>
{:else if !email}
  <p class="container" data-cy="missing-account-id">
    email not specified. Please contact your system administrator for help. Most likely the link to this page is missing
    the <code>?email</code> parameter.
  </p>
{:else if !$isLoadingAuth && $isAuthenticated}
  <Load query={profileQuery} name="profile">
    {#if accountid && $profileQuery.data.profiles?.data?.length === 0}
      <AccountInitialization accountId={accountid} on:created={() => location.reload()} />
    {:else}
      <Load query={productsQuery} name="products">
        <SupportWidgetViewport {userCountry} {inventories} {email} />
      </Load>
    {/if}
  </Load>
{/if}
